import React, { FunctionComponent, useState } from "react";

import { Stack, useTheme } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { Permissions } from "@libs/permissions/permissions.enum";

import { SystemPltTabs } from "../system-plt-tabs.constants";
import { AddRedirectLinkDialog } from "./components/add-redirect-link-dialog/AddRedirectLinkDialog";
import { RedirectsFilter } from "./components/RedirectsFilter";
import { RedirectsList } from "./components/RedirectsList";

const RedirectsScreenBase: FunctionComponent = () => {
  const theme = useTheme();

  const [linkId, setLinkId] = useState<string | null | undefined>();

  return (
    <Stack
      verticalFill
      styles={{ root: { padding: theme.spacing.s1 } }}
      tokens={{ childrenGap: theme.spacing.l2 }}
    >
      <Stack horizontalAlign="space-between" horizontal>
        <SectionTitle>
          {SystemPltTabs.Redirects.RedirectLinks.name}
        </SectionTitle>
        <AddRedirectLinkDialog setLinkId={setLinkId} linkId={linkId} />
      </Stack>
      <RedirectsFilter>
        {({ values }) => (
          <RedirectsList
            setLinkId={setLinkId}
            linkId={values.linkId}
            hasPin={values.hasPin}
          />
        )}
      </RedirectsFilter>
    </Stack>
  );
};

export const RedirectsScreen = withPermissions(
  RedirectsScreenBase,
  [Permissions.PltRedirectRead, Permissions.PltRedirectWrite],
  "or"
);
